module.exports = __webpack_public_path__ + "img/flow-04.88cc5837.jpg";